import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import isNil from 'lodash/isNil';

import { Icon, MaterialHint } from 'shared/components';

import { CONNECTING, IN_PROGRESS, DISCONNECTED, UNANSWERED, DECLINED, PENDING } from 'modules/common/constants/conversationStatuses';
import { CONVERSATION_STATUS_TITLES } from 'modules/queues/constants/conversationStatusTitles';

import { getLastConversationDateFormatted } from 'shared/utils/dateTimeUtils';

import theme from './AppointmentLastConversation.scss';

const propTypes = {
  start: PropTypes.number,
  end: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  status: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

const defaultProps = {
  start: null,
  end: null,
  status: null,
};

const AppointmentLastConversation = ({ start, end, status, intl }) => {
  const conversationTime = [CONNECTING, IN_PROGRESS, PENDING].includes(status) ? start : end;
  return (
    <If condition={ !isNil(CONVERSATION_STATUS_TITLES[status]) && !isNil(conversationTime) }>
      <div className={ theme.root }>
        <div
          className={ classNames(theme.tooltip, {
            [theme.highlightRed]: [DISCONNECTED, UNANSWERED, DECLINED].includes(status),
            [theme.highlightOrange]: [PENDING].includes(status),
            [theme.highlightGreen]: [CONNECTING, IN_PROGRESS].includes(status),
          }) }
        >
          <MaterialHint
            placement="top"
            title={ <FormattedMessage { ...CONVERSATION_STATUS_TITLES[status].title } /> }
          >
            <div>
              <Icon name={ CONVERSATION_STATUS_TITLES[status].iconName } />
            </div>
          </MaterialHint>
        </div>
        <div className={ theme.lastConversation }>
          { getLastConversationDateFormatted(conversationTime, intl) }
        </div>
      </div>
    </If>
  );
};

AppointmentLastConversation.propTypes = propTypes;
AppointmentLastConversation.defaultProps = defaultProps;

export default AppointmentLastConversation;
